import { useCallback, useState } from 'react';
import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import Paper from '@/views/components/Paper/Paper';
import FooterContentCard from '@/views/screens/common/FooterContentCard';

import AddProductFullModal from '../../../common/AddProductFull/AddProductFullModal';
import LADClaimsItemCard from '../../Edit/Items/LADClaimsItemCard';

const CreateLADItems = ({ items, setItems }) => {
  const [addProductModal, setAddProductModal] = useState(false);
  const [addProductModalIndex, setAddProductModalIndex] = useState(false);

  const setEditMode = (index, val) => {
    const itemsLocal = cloneDeep(items);
    itemsLocal[index].editMode = val;
    setItems(itemsLocal);
  };

  const handleAddNew = (currentIndex) => {
    const itemsLocal = cloneDeep(items);
    let nextSequence = maxBy(itemsLocal, ({ itemSeq }) => Number(itemSeq));
    nextSequence = nextSequence ? nextSequence.itemSeq : 0;
    const newItem = {
      claimKey: 0,
      dirtyFlag: 'i',
      editMode: true,
      isNew: true,
      itemSeq: nextSequence + 1,
      smAmount: undefined,
    };
    if (currentIndex === undefined || currentIndex === -1) {
      itemsLocal.push(newItem);
    } else {
      itemsLocal.splice(currentIndex + 1, 0, newItem);
    }
    setItems(itemsLocal);
  };

  const handleCancel = (index, isNew) => {
    const itemsLocal = cloneDeep(items);
    if (isNew) {
      if (itemsLocal.length === 1) {
        showNotification({
          message: 'At least one claim item is required. Cannot cancel.',
          type: NOTIFICATION_TYPES.ERROR,
        });
        return;
      }
      itemsLocal.splice(index, 1);
    } else {
      itemsLocal[index] = {
        ...itemsLocal[index],
        editMode: false,
      };
    }
    setItems(itemsLocal);
  };

  const handleSubmit = (data, index) => {
    const itemsL = cloneDeep(items);
    itemsL[index] = {
      ...data,
      dirtyFlag: 'i',
      editMode: false,
      isNew: false,
    };
    setItems(itemsL);
  };

  const handleDelete = useCallback(
    (index) => {
      if (items && items.length <= 1) {
        showNotification({
          message: 'At least one claim item is required. Cannot delete.',
          type: NOTIFICATION_TYPES.ERROR,
        });
        return;
      }
      const itemsL = cloneDeep(items);
      itemsL.splice(index, 1);
      setItems(itemsL);
    },
    [items, setItems],
  );

  const handleNewProductModal = (index) => {
    setAddProductModalIndex(index);
    setAddProductModal(true);
  };

  const onSelectAddressBook = (data) => {
    const itemsLocal = cloneDeep(items);
    itemsLocal[addProductModalIndex] = {
      ...itemsLocal[addProductModalIndex],
      claimantValue: data.claimantValue,
      editMode: true,
      fullRelFlag: data.fullRelFlag,
      isNew: true,
      itemCode: data.productCode,
      itemDesc: data.productDesc,
      itemUnitMeasure: data.productUnitMeasure,
      itemUnitWeight: data.productWeight,
    };
    setItems(itemsLocal);
    handleAddProductModalClose();
  };

  const handleAddProductModalClose = () => {
    setAddProductModal(false);
    setAddProductModalIndex(false);
  };

  const totalProductClaimAmount = items?.reduce((sum, item) => sum + parseFloat(item.productClaimAmount || 0), 0);

  return (
    <div className="d-flex flex-direction-column h-100 overflow-hidden">
      <Divider className="mt-0 my-16 ml-n16 vw-100" />
      <div className="flex-1 custom-scroll-bar">
        <div className="px-15">
          {items.map((row, index) => (
            <LADClaimsItemCard
              itemDetails={row}
              key={row.itemSeq}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
              handleNewProductModal={handleNewProductModal}
              handleAddNew={handleAddNew}
              shouldUpdateClaimantValueFromItemModal
              totalItemsCount={items.length}
            />
          ))}
        </div>
      </div>
      <div className="px-15">
        <Paper className="background-header px-16 py-5">
          <Row justify="space-around" className="px-10" gutter={10}>
            <Col>
              <FooterContentCard
                reverse
                align="middle"
                count={totalProductClaimAmount}
                label="Total Product Claim Amount"
                contentClass="text-white f-16 fw-600"
                labelClass="text-light f-14"
                defaultValue={0}
              />
            </Col>
          </Row>
        </Paper>
      </div>
      <AddProductFullModal
        addressBookModal={addProductModal && addProductModalIndex !== false}
        onSelectAddressBook={onSelectAddressBook}
        handleAddressBookModalClose={handleAddProductModalClose}
      />
    </div>
  );
};

export default CreateLADItems;
